<template>
    <div>
        <div class="has-text-weight-bold">{{activeDates}}</div>
        <div class="is-size-7">Flat Price: {{ price.flat_price | currency }}</div>
        <div class="is-size-7">Price-per-Unit: {{ price.per_unit_price | currency }}</div>
    </div>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'PriceSchedule',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            price: {
                type: Object,
                required: true
            }
        },
        data: function() {
            return {};
        },
        computed: {
            activeDates: function() {
                let s = moment(this.price.enabled_at);
                let e = moment(this.price.disabled_at);
                if (s.isSame(e, 'day')) {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('h:mm a');
                } else if (s.isSame(e, 'month')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else if (s.isSame(e, 'year')) {
                    return s.format('MMM D, h:mm a - ') + e.format('MMM D, h:mm a, YYYY');
                } else {
                    return s.format('MMM D, YYYY, h:mm a - ') + e.format('MMM D, YYYY, h:mm a');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>

</style>
